import WidgetBase from '../widget.base';
import BackToTopService from '../../services/back-to-top';
import { each  } from 'App/lib/util';
import { mq } from '../../lib/util';
import SendRequest from "../../lib/ajax";
var $ = window.$;
window.jQuery = $;

//this classes uses fullcalendar jquery plugin

export default class EventsWidget extends WidgetBase {
    static selector = '[data-js-events]';

    constructor(el) {
        super(el);

        //we have jquery on this page. Might as well use it.

        this.$el = $(el);
        this.$calendar = this.$el.find("#calendar"); //the actual calendar
        this.$cards = this.$el.find('[data-js-card]'); //cards on the grid
        this.$gridView = this.$el.find('[data-js-grid]').first(); //grid container
        this.$calendarView = this.$el.find('[data-js-calendar]').first(); //calendar container
        this.$filters = this.$el.find('[data-filter]'); //filter buttons
        this.$currentFilter = this.$el.find('[data-filter="all"]'); //holds the current filter button
        this.$subFilters = this.$el.find('[data-subfilter]'); //dropdown sub filters
        this.$loader = this.$el.find('[data-js-loader]'); //loading icon
        this.$columns = this.$el.find('[data-js-col]'); //card container. used for flex grid
        this.$listings = this.$el.find('[data-listings]'); //the outer container for listings
        this.events = [];
        this.filterEvents = [];
        this.dropdownIsOpen = false;

        this.gridViewShowing = true;
        this.calendarHasLoaded = false;

        this.filters = {
            fromCal: false,
            month:"",
            location:""
        }

        const urlVariables = this.getUrlVars();
        if(urlVariables.location != null){
            this.filters.location = decodeURIComponent(urlVariables.location);
        }
        if(urlVariables.month != null){
            this.filters.month = decodeURIComponent(urlVariables.month);
        }

        this.applyFilters(urlVariables);

        //remove disabled class on calendar toggle icon
        this.$el.find('.disabled').removeClass('disabled');

        //icons that control the view
        this.viewToggles2 = this.$el.find('[data-view-toggle]');

        //keep track of min date between week views
        this.minTime = null;
        this.$firstEventElm = null;

        this.viewToggles2.on('click', this.toggleView.bind(this));
        this.$filters.on('click', this.filterClick.bind(this));
        this.$subFilters.on('click', this.subfilterClick.bind(this));
        $(window).on('resize', this.windowResized.bind(this));

        this.fetchCalendarEvents().then((data) => {
            this.$loader.hide();
            this.events = data;
            this.filterEvents = data;
            this.initCalendar();
            this.calendarHasLoaded = true;
            this.applyFilters(urlVariables);

            this.checkForZeroResults();
        });

        BackToTopService.init(el, true);

       //------------------
        //MOCK TEST DATA
        //-----------------
        // setTimeout(function(){
        //     this.events = [
        //         {
        //           title  : 'event1',
        //           start  : '2018-10-14T17:30:00'
        //         },
        //         {
        //           title  : 'event2',
        //           start  : '2018-10-25',
        //           end    : '2018-10-27'
        //         },
        //         {
        //           title  : 'event3',
        //           start  : '2018-10-09T12:30:00',
        //           allDay : false // will make the time show
        //         }
        //       ]
        //       this.$loader.hide();
        //       this.initCalendar();
        //           this.calendarHasLoaded = true;
        //         if(this.gridViewShowing === true){
        //             this.$calendarView.hide();
        //         }
        //       this.calendarHasLoaded = true;
        // }.bind(this), 3000);

        setTimeout(() => {
            this.loaded();
        })
    }

    //this method is called when the page loads and the user selected filters. Navigated to an event. Then clicked back.
    //maintain state in query string params. and apply location/month filters
    applyFilters(urlVariables){
        if(urlVariables.location != null && urlVariables.location.length > 0){
            const locationName = decodeURIComponent(urlVariables.location);
            this.removeCurrentActiveFilter();
            this.filterGrid(null, locationName);
            if(this.calendarHasLoaded === true){
                this.filterCalendar('location', locationName);
            }
            const $locationBtn = this.$el.find('button[data-filter="Store Name"]');
            this.$currentFilter = $locationBtn;
            $locationBtn.addClass('active').text(locationName);
        }

        if(urlVariables.month != null && urlVariables.month.length > 0){
            const monthName = decodeURIComponent(urlVariables.month);
            this.removeCurrentActiveFilter();
            this.filterGrid(null, monthName);
            if(this.calendarHasLoaded === true){
                this.filterCalendar('month', monthName);
            }
            const $monthBtn = this.$el.find('button[data-filter="month"]');
            this.$currentFilter = $monthBtn;
            $monthBtn.addClass('active').text(monthName);
        }
    }

    constructUrl(){
        const doc = document;
        const query = $.param(this.filters);
        window.history.replaceState(null, null, doc.location.origin + doc.location.pathname + "?"+ query);
    }

    getUrlVars() {
        let vars = {};
        const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {
            vars[key] = value;
        });
        return vars;
    }

    fetchCalendarEvents(){
        let url = "/umbraco/rhythm/EventPromotionApi/all";
        const request = new SendRequest(url);

        return request.then((data) => JSON.parse(data.text))
    }



    filterGrid(filter, value){

        if(filter === 'all'){
            this.$columns.show();

        }
        else if(value != null){
            //loop through all of the card columns
            //if the card column's category array has the value being filtered, show it

            this.$columns.hide();
            const filterValue = value;
            this.$columns.each((index, el) => {
                const filterCategories = el.dataset.filterCategories;
                if(filterCategories==null){return;}
                const categoryArr = JSON.parse(filterCategories);
                each(categoryArr, (category) => {
                    if(filterValue.toUpperCase() === category.toUpperCase()){
                         $(el).show();
                    }
                });
            });
        } else{

        }
    }

    filterCalendar(filter, value){
        //remove all events
        this.$calendar.fullCalendar('removeEvents');
        //rerender all events
        if(filter === 'all'){
            this.$calendar.fullCalendar('renderEvents', this.events, true);
        }

        //remove all events. Add only the ones with the correct location name. Re render events
        else if(filter === 'location' && value != null){
            this.filterEvents = [];


            each(this.events, (event) =>{
                if(event.locationName.toUpperCase() === value.toUpperCase()){
                    this.filterEvents.push(event);
                }
            });

            //the 'true' at the end is to have the event stick to the calendar
            //so when you navigate from view to view, the event won't disappear once it's added
            //not sure why it was implemented this way, but we need this 'true'
            this.$calendar.fullCalendar('renderEvents', this.filterEvents, true);

        //navigate to the appropriate month based on filter vlaue
        } else if(filter === 'month' && value != null){
            //show all events.
            this.$calendar.fullCalendar('renderEvents', this.events, true);
            this.navigateToMonth(value);
        }
    }

    navigateToMonth(month){
        const monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE","JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

        //this will return 1-12
        let newMonth = monthNames.indexOf(month.toUpperCase()) + 1;
        const currentMonth = new Date().getMonth() + 1;

        //the filters are only this current month and future. So if the value is less, it's in the future
        let isNextYear = newMonth < currentMonth ? true : false;
        let targetYear = new Date().getFullYear();
        targetYear = isNextYear ? targetYear + 1 : targetYear;

        newMonth = newMonth < 10 ? "0" + newMonth : "" + newMonth;
        const targetFilterDate = ""+targetYear + "-" + newMonth + "-01T12:00:00";
        this.$calendar.fullCalendar('gotoDate', targetFilterDate);

    }

    checkIfFilterIsDropdown($element){
        return $element.next().is('[data-dropdown]');
    }

    removeCurrentActiveFilter(){
        this.$currentFilter.removeClass('active');
    }

    subfilterClick(e){
        e.stopPropagation();
        const $element = $(e.currentTarget); //dropdown button
        const $dropdownButton = $element.parent().prev(); //main menu button that triggers dropdown
        const filterType = $dropdownButton.data().filter; //location, month
        const subFilter = $element.data().subfilter; //sub filter value

        this.removeCurrentActiveFilter();
        this.$currentFilter = $dropdownButton;
        this.filterGrid(filterType, subFilter);
        this.filterCalendar(filterType, subFilter);
        this.closeDropDown($dropdownButton, false);
        $dropdownButton.text(subFilter);

        switch(filterType){
            case 'location':
            this.filters.location = subFilter;
            this.filters.month = "";
            break;

            case 'month':
            this.filters.month = subFilter;
            this.filters.location = "";
            break;

            default:
            break;
        }

        this.constructUrl();

        //change the button text to the sub filter value name. i.e. October
        this.$filters.each((index, element) => {
            if($(element).next().is('[data-dropdown]') && !$dropdownButton.is($(element))){
                const text = $(element).data().filter.toUpperCase();
                $(element).text(text);
            }
        });
    }

    filterClick(e){
        e.stopPropagation();
        const $element = $(e.currentTarget);
        const filterType = $element.data().filter; //eg month, location, all
        const isDropdown = this.checkIfFilterIsDropdown($element);
        //check if dropdown
        if(isDropdown){
            const isOpen = $element.parent().hasClass('open');
            const $dropdownFilters = this.$el.find('[data-dropdown]').prev();
            this.closeDropDown($dropdownFilters, true);

            if(isOpen){
                // $element.removeClass('active');
                this.closeDropDown($element, true);
                return;
            } else if(isOpen === false) { //dropdown is not active
                // this.removeCurrentActiveFilter();
                this.showDropDown($element);

                this.dropdownIsOpen = true;
                return;
            } else{
                return;
            }
        } else {
            this.removeCurrentActiveFilter();
        }

        this.$currentFilter = $element;
        this.removeCurrentActiveFilter();
        if(!isDropdown){
            this.$currentFilter.addClass('active');
            this.filterGrid(filterType);
            this.filterCalendar(filterType);

            //VIEW ALL
            this.filters.location = "";
            this.filters.month = "";
            this.constructUrl();
            //reset dropdown values to their initial filter text (Month, Location)
            this.$filters.each((index, element) => {
                if($(element).next().is('[data-dropdown]')){
                    const text = $(element).data().filter.toUpperCase();
                    $(element).text(text);
                }
            });
        }
    }

    showDropDown($element){
        $element.addClass('active').parent().addClass('open');
        document.addEventListener('click', this.closeDropDown.bind(this, $element));
    }

    closeDropDown($element, deactivate = true){
        if(deactivate){
            $element.removeClass('active').parent().removeClass('open');
        } else{
            $element.parent().removeClass('open');
        }
        if(this.checkIfFilterIsDropdown(this.$currentFilter)){
            this.$currentFilter.addClass('active');
        }
        $element.blur();
        document.removeEventListener('click', this.closeDropDown);
    }

    toggleView(e){
        const view = e.currentTarget.dataset.viewToggle;
        switch(view){
            case 'calendar':
                this.showCalendarView();
            break;
            case 'grid':
                this.showGridView();
            break;
            default: break;
        }
    }

    showCalendarView(){
        //no calendar view on mobile!
        if(!mq('sm')){
            return;
        }
        this.filters.fromCal = true;
        this.constructUrl();

        this.$gridView.hide();
        this.$cards.addClass('hidden'); //adds opacity and transform for animation
        const $cal = this.$calendar;
        const self = this;
        this.$calendarView.removeClass('hidden').show(); //show the view containing the calendar

        if(this.calendarHasLoaded === true){
            $cal.fullCalendar('render'); //adjust size of the calendar so it doesn't look bad
            $cal.fullCalendar('rerenderEvents'); //render events so they appear nicely
            self.scrollToCurrentTime(true); //for agenda week only
        }
        this.gridViewShowing = false;
        this.$calendar.removeClass('hidden'); //fade calendar in. This occurs once the calendar has properly resized

        this.toggleViewOptions('calendar');
    }

    showGridView(){
        this.filters.fromCal = false;
        this.constructUrl();
        this.gridViewShowing = true;
        this.$gridView.show();
        $(".fc-scroller").scrollTop(0);

        if(this.calendarHasLoaded){
            this.$calendarView.hide();
        }

        let animationIndex = 1;
        this.$cards.each(function(index, card){
            if($(card).parent().is(':visible')){
                setTimeout(function(){
                    card.classList.remove('hidden');
                }, animationIndex * 75);
                animationIndex++;
            } else{
                card.classList.remove('hidden');
            }
        });
        this.$calendar.addClass('hidden');

        this.toggleViewOptions('grid');
    }

    toggleViewOptions(view){
        $(".active[data-view-toggle]").removeClass('active');
        $("[data-view-toggle='"+view+"']").addClass('active');
    }

    scrollToCurrentTime(animate = false){
        let scrollTime = new Date().getHours();
        scrollTime = scrollTime < 10 ? "0" + scrollTime : scrollTime;
        scrollTime = scrollTime +":00:00";
        const el = $("[data-time='"+scrollTime+"']");
        if(el==null || el.length == 0){return;}
        const elOffset = el.position().top;
        const elHeight = el.height() * 2;
        const windowHeight = $('.fc-scroller').height();
        let offset;

        if (elHeight < windowHeight) {
            offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
        }
        else {
            offset = elOffset;
        }
        if(animate){
            $(".fc-scroller").animate({scrollTop: offset}, 300);
        } else{
            $(".fc-scroller").scrollTop(offset);

        }
    }

    initCalendar(){
        this.$calendar.fullCalendar({
            defaultView:'agendaWeek',
            nowIndicator: true,
            header:{
                center:'title',
                left:'prev,next today',
                right:'agendaWeek,month'
            },
            scrollTime: "00:00:00",
            eventRender: this.eventRender.bind(this),
            eventColor:'#07B1E9',
            viewRender: this.viewRender.bind(this),
            eventLimit: true,
            eventAfterAllRender: this.eventAfterAllRender.bind(this),

            views:{
                month:{
                    eventLimit:5,
                    timeFormat: 'h:mmt'
                },
                agenda:{
                    columnHeaderFormat:'D - ddd',
                    slotLabelFormat:'h a',
                    displayEventTime: false
                }
            },
            events:this.filterEvents
        });
    }

    checkForZeroResults() {
        let visibleCount = this.$listings.children().length
        each(this.$listings.children(), (listing) => {
            if(listing.offsetParent === null) {
                visibleCount--;
            }
        })

        if(!visibleCount) {
            this.$listings.addClass('no-results');
        }else{
            this.$listings.removeClass('no-results');
        }
    }

    //---------------------------------
    //CALENDAR CALLBACKS
    //---------------------------------

    eventRender(event, element, view){
        //adds the feature star icon
        if(event.featured){
            if(view.name==="month"){
                element.find('.fc-content').prepend($('<span class="fc-preferred"><i class="icomoon icomoon--star"></i></span>'));
            }
            else{
                element.find('.fc-content >div:first').prepend($('<span class="fc-preferred"><i class="icomoon icomoon--star"></i></span>'));
            }
        }
    }

    eventAfterAllRender(view){

        if(view.name === "agendaWeek"){

            //checks to see if the section has any full day events. If not, hide it as it is just empty white space
            const allDayEvents = $(".fc-day-grid-event:not(.cal-filter-hidden)").length;
            if(allDayEvents > 0){
                $(".fc-day-grid.fc-unselectable").show()
            } else {
                $(".fc-day-grid.fc-unselectable").hide()
            }
        }
    }

    viewRender(view, element){
        if(view.name === 'agendaWeek'){
            if(this.gridViewShowing === false){
                this.scrollToCurrentTime();
            }
        }
    }

    windowResized(){
        if(!mq('sm')){
            if(this.gridViewShowing == false){
                this.showGridView();
                $(".events-header__view-toggle").blur();
            }
        }
    }
}